import { atom } from 'recoil';
import { IntroduceInfoResponse } from '@/types/api/mypage/introduceInfo';

/** お友達紹介クーポン表示用 */
const introduceInfoState = atom<IntroduceInfoResponse>({
  key: 'introduceInfoState',
  default: {
    is_promotion_code_apply: false,
    promotion_code: '',
    promotion_code_expires: '',
    is_promotion_code_expired: true,
    introduce_count: 0,
  },
});

export default introduceInfoState;
